// extracted by mini-css-extract-plugin
export default {"spinner_container":"processing-indicator_spinner_container__4eUJf","process_container":"processing-indicator_process_container__vi7c+"};